import { RecorderSituationsState, RootState } from '../types';

export const getRecorderSituations = (state: RootState): RecorderSituationsState =>
  state.recorderSituations;
